import React from 'react';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        padding: '0 24px',
        boxSizing: 'border-box'
    },
    titleContent: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center'
    },
    monthTitle: {
        fontSize: '24px',
        fontWeight: 800,
        lineHeight: '33px',
        color: '#1F1F51'
    },
    monthTitleMuted: {
        color: '#A6A6BF'
    },
    collapseButton: {
        background: 'none',
        border: 'none',
        color: '#1F1F51',
        cursor: 'pointer',
        flexShrink: 0,
        padding: 0,
        width: '16px',
        '& i': {
            fontSize: '16px'
        }
    },
    collapseButtonMuted: {
        color: '#A6A6BF'
    },
    collapseSpacer: {
        flexShrink: 0,
        width: '16px'
    }
}));

type ExpandedTitleRowProps = {
    collapsable?: boolean;
    muted?: boolean;
    onCollapse?: () => void;
    title: string;
};

const ExpandedTitleRow: React.FC<ExpandedTitleRowProps> = ({
    collapsable = false,
    muted = false,
    onCollapse,
    title
}) => {
    const classes = useStyles();

    return (
        <div className={classes.titleRow}>
            {collapsable && <span className={classes.collapseSpacer} />}
            <div className={classes.titleContent}>
                <span
                    className={`${classes.monthTitle} ${muted ? classes.monthTitleMuted : ''}`}
                >
                    {title}
                </span>
            </div>
            {collapsable ? (
                <button
                    className={`${classes.collapseButton} ${muted ? classes.collapseButtonMuted : ''}`}
                    onClick={onCollapse}
                    type="button"
                >
                    <i className="fas fa-chevron-up" />
                </button>
            ) : null}
        </div>
    );
};

export default ExpandedTitleRow;
